module.exports = __webpack_public_path__ + "img/case-banner.1e2b879d.png";